import React from 'react';
import LazyImage from '../src/components/LazyImage';
const FoundersSection = () => {
  return <section id="meet-us" className="w-full py-16 sm:py-24 observer-element bg-gradient-to-b from-white to-gold-50" data-id="element-103">
      <div className="container mx-auto px-4" data-id="element-104">
        <div className="text-center mb-12 sm:mb-16 fade-in" data-id="element-105">
          <h2 className="text-3xl sm:text-5xl font-bold section-title-decoration" data-id="element-106">
            Meet <span className="text-gradient" data-id="element-107">the Founders</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 items-center" data-id="element-108">
          <div className="rounded-lg overflow-hidden shadow-xl" data-id="element-109">
            <LazyImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/uDq2sVieMxguTNrnjMyEbR/Screenshot_2025-06-18_at_9.49.51_PM.png" alt="Curtis and Spring Eatmon" className="w-full h-auto object-cover rounded-lg" data-id="element-110" />
          </div>
          <div className="bg-white border border-gold-200 rounded-lg p-6 sm:p-8 hover-card shadow-lg" data-id="element-111">
            <p className="text-gray-700 mb-6 fade-in text-sm sm:text-base" data-id="element-112">
              We're Curtis & Spring Eatmon—faith-driven entrepreneurs, coaches,
              and the power couple behind Max Life Agency, Legacy Lab, and a
              growing faith-based media company. Our mission is to help
              individuals, couples, and families build wealth, protect their
              peace, and create legacies that outlive them.
            </p>
            <div className="elegant-divider my-4 sm:my-6" data-id="element-113"></div>
            <p className="text-gray-700 fade-in text-sm sm:text-base" style={{
            transitionDelay: '0.2s'
          }} data-id="element-114">
              Together, we've built multiple six and seven-figure businesses
              while raising a kingdom-minded family. We now coach people through
              the very principles we live by—blending faith, finance, marriage,
              and leadership into a life of purpose and impact.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default FoundersSection;